export const activeTasks = (state) => state.activeTasks;
export const completedTasks = (state) => state.completedTasks;

export const activeTasksNr = (state) => (state.activeTasks && state.activeTasks.totalCount ? state.activeTasks.totalCount : 0);

export const completedTasksNr = (state) => (state.completedTasks && state.completedTasks.totalCount ? state.completedTasks.totalCount : 0);

export const all = (state) => state.all;

export const getSelectedTasksFilter = (state) => state.selectedTasksFilter;

export const getSelectedAppName = (state) => state.selectedAppName;
